module.exports = __webpack_public_path__ + "img/Container Loading Supervision_wei.281e5b51.png";